"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderWizardView = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var NavigateConfirmation_1 = require("components/NavigateConfirmation");
var sok_ui_1 = require("@caddigital/sok-ui");
var distributionListsActions = require("@caddigital/sok-reducers/lib/actions/order/distributionLists");
var deliveryMethodsActions = require("@caddigital/sok-reducers/lib/actions/order/deliveryMethods");
var finishingsActions = require("@caddigital/sok-reducers/lib/actions/order/finishings");
var AddressBookActions = require("@caddigital/sok-reducers/lib/actions/order/addressBook");
var printProvidersActions = require("@caddigital/sok-reducers/lib/actions/order/printProviders");
var RecipientsActions = require("@caddigital/sok-reducers/lib/actions/order/recipients");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var BillingInformationsActions = require("@caddigital/sok-reducers/lib/actions/order/billingInformations");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var FooterComponents_1 = require("./FooterComponents");
var step1_1 = require("./steps/step1");
var step2_1 = require("./steps/step2");
var step3_1 = require("./steps/step3");
var step4_1 = require("./steps/step4");
var step5_1 = require("./steps/step5");
require("./style.scss");
var helpers_1 = require("./helpers");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        isFetching: state.order.wizard.isFetching,
        isSaving: state.order.wizard.isSaving,
        wizardStep: state.order.wizard.wizardStep,
        checkingFiles: state.order.wizard.checkingFiles,
        user: state.auth.current.user,
        cart: state.cart,
        author: state.order.wizard.values.author,
        deleteStatus: state.order.list.deleteStatus,
        status: state.order.wizard.values.status,
        orderId: state.order.wizard.values.orderId,
        modified: state.order.wizard.values.modified,
        proceedWithoutInvalidFiles: state.order.wizard.values.proceedWithoutInvalidFiles,
        orderFilesStatus: state.order.wizard.orderFilesStatus
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    changeStep: function (step, mode, type) { return function () {
        return dispatch(WizardActions.changeStep(step, mode, type));
    }; },
    fetchExternalUsers: function (folder) { return function () {
        return dispatch(AddressBookActions.fetchRequest(folder));
    }; },
    fetchRecipients: function (project) { return function () {
        return dispatch(RecipientsActions.fetchRequest(project));
    }; },
    fetchDistributionLists: function (project) { return function () {
        return dispatch(distributionListsActions.fetchRequest(project));
    }; },
    fetchBillingInformations: function (project) { return function () {
        return dispatch(BillingInformationsActions.fetchBillingInformationsRequest(project));
    }; },
    fetchOrderInformations: function () { return (dispatch(deliveryMethodsActions.Actions.fetchRequest()),
        dispatch(finishingsActions.Actions.fetchRequest()),
        dispatch(printProvidersActions.Actions.fetchRequest())); },
    setDesiredDeliveryTime: function (date) {
        return dispatch(WizardActions.valuesSetRequestTimeOfDelivery(date.format('YYYY-MM-DD HH:mm:ssZZ')));
    },
    prevalidateFiles: function (folder, files, type) {
        return dispatch(WizardActions.prevalidateFilesRequest(folder.id, files, type));
    },
    clear: function () { return (dispatch(AddressBookActions.clearState()),
        dispatch(RecipientsActions.clearState()),
        dispatch(WizardActions.clearWizard()),
        dispatch(deliveryMethodsActions.Actions.clear()),
        dispatch(printProvidersActions.Actions.clear()),
        dispatch(finishingsActions.Actions.clear()),
        dispatch(BillingInformationsActions.clearState()),
        dispatch(distributionListsActions.clearState())); },
    fetchOrder: function (id, mode, type) {
        return dispatch(WizardActions.fetchOrderRequest(id, mode, type));
    },
    fetchOrderRecipients: function (id, mode) {
        return dispatch(WizardActions.fetchRecipients(id, mode));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var mapDispatchToPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var getStep = function (props, disableWizardFields) { return ({
    0: (React.createElement(step1_1.default, { currentProject: props.currentProject, currentFolder: props.currentFolder, type: props.type, mode: props.mode, disableWizardFields: disableWizardFields })),
    1: (React.createElement(step2_1.default, { currentProject: props.currentProject, currentFolder: props.currentFolder, type: props.type, mode: props.mode, disableWizardFields: disableWizardFields })),
    2: (React.createElement(step3_1.default, { selectedLanguage: props.selectedLanguage, currentFolder: props.currentFolder, metadata: props.metadata, type: props.type, mode: props.mode, disableWizardFields: disableWizardFields })),
    3: (React.createElement(step4_1.default, { selectedLanguage: props.selectedLanguage, currentProject: props.currentProject, type: props.type, mode: props.mode, disableWizardFields: disableWizardFields, metadata: props.metadata })),
    4: (React.createElement(step5_1.default, { currentFolder: props.currentFolder, type: props.type, mode: props.mode }))
}); };
var OrderWizardPure = function (props) {
    var perm = props.currentProject.perm & ~acl.FEATURE_MASK;
    var disableWizardFields = props.isSaving !== 'SAVING'
        ? props.type === 'AUTOMATIC' && props.orderId
            ? props.user.fold(true, function (user) {
                return !!(perm & acl.PROJECT_ADMIN_GRANT)
                    ? false
                    : props.author && user.uuid === props.author.uuid
                        ? false
                        : true;
            })
            : props.mode === 'VIEW'
        : true;
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'order-wizard-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/projects/").concat(props.currentProject.id) }, props.currentProject.name),
                    React.createElement("span", null, props.type === 'SINGLE'
                        ? (0, translation_1.getLocalization)('userfront/order/wizard')
                        : (0, translation_1.getLocalization)('userfront/order/automaticWizard'))),
                (function (props) {
                    if (props.isFetching === 'FAILED') {
                        return (React.createElement("div", { className: 'center-content' },
                            React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('userfront/orderWizard/error') })));
                    }
                    if (props.isFetching === 'FETCHING' ||
                        (props.mode === 'EDIT' && props.isFetching === 'STANDBY')) {
                        return (React.createElement("div", { className: 'center-content' },
                            React.createElement(sok_ui_1.LoadingSpinner, { key: 'spinner', className: 'order-wizard-step1-fetching' })));
                    }
                    if (!(props.mode === 'EDIT' || props.type === 'AUTOMATIC') &&
                        (props.checkingFiles.status === 'FAILED' ||
                            (props.type === 'SINGLE' &&
                                ['VALID', 'STANDBY', 'FAILED'].includes(props.checkingFiles.status) &&
                                props.checkingFiles.files.length === 0))) {
                        return (React.createElement("div", { className: 'order-wizard-step1' },
                            React.createElement("div", { className: 'order-wizard-step1-loading center-content loading-invalid-files' },
                                React.createElement("div", { className: "warning-icon" },
                                    React.createElement(sok_ui_1.Icon, { className: "fa-exclamation-triangle", prefix: 'fal' })),
                                React.createElement("div", { className: 'information-text' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/checkingFiles/noFiles')))));
                    }
                    if (props.checkingFiles.status === 'CHECKING' &&
                        props.wizardStep === 0) {
                        return (React.createElement("div", { className: 'order-wizard-step1' },
                            React.createElement("div", { className: 'order-wizard-step1-loading center-content' },
                                React.createElement(sok_ui_1.LoadingSpinner, { key: 'spinner' }),
                                React.createElement("div", { key: 'text', className: 'information-text' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/checkingFiles/loading')))));
                    }
                    return (React.createElement(React.Fragment, null,
                        props.wizardStep < 4 && (React.createElement(React.Fragment, null,
                            React.createElement(sok_ui_1.RequestStatusBox, { key: 'request', status: props.isSaving, statusList: ['INITIAL', 'SAVING', 'SAVED', 'FAILED'] },
                                (0, translation_1.getLocalization)('userfront/orderWizard/saving'),
                                (0, translation_1.getLocalization)('userfront/orderWizard/saved'),
                                (0, translation_1.getLocalization)('userfront/orderWizard/failed')),
                            React.createElement(sok_ui_1.StepBar, { key: 'stepbar', currentStep: props.wizardStep, steps: ['1', '2', '3', '4'], showStepText: false, onChange: function (step) {
                                    return props.changeStep(step, props.mode, props.type)();
                                } }))),
                        getStep(props, disableWizardFields)[props.wizardStep]));
                })(props),
                React.createElement(sok_ui_1.Footer, null,
                    React.createElement(FooterComponents_1.FooterComponents, { key: 'components', currentFolder: props.currentFolder, currentProject: props.currentProject, user: props.user, type: props.type, mode: props.mode, disableWizardFields: disableWizardFields, history: props.history })))),
        React.createElement(NavigateConfirmation_1.default, { display: (props.mode !== 'VIEW' &&
                props.type !== 'SINGLE' &&
                !props.isSaving.includes('SAVED') &&
                props.modified) ||
                (props.mode !== 'VIEW' &&
                    props.type === 'SINGLE' &&
                    (!props.isSaving.includes('SAVED') || props.modified)), firstRow: (0, translation_1.getLocalization)('userfront/orderWizard/unsavedChanges'), secondRow: (0, translation_1.getLocalization)('userfront/orderWizard/areYouSure') })));
};
var lifecycles = (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchDistributionLists(this.props.currentProject)();
        this.props.fetchBillingInformations(this.props.currentProject)();
        this.props.fetchRecipients(this.props.currentProject)();
        this.props.fetchExternalUsers(this.props.currentFolder)();
        this.props.fetchOrderInformations();
        this.props.setDesiredDeliveryTime((0, helpers_1.initDate)());
        if (this.props.mode === 'EDIT' || this.props.mode === 'VIEW') {
            var id = parseInt(this.props.match.params.id, 10);
            this.props.fetchOrderRecipients(id, this.props.type === 'AUTOMATIC' ? 'EDIT' : this.props.mode);
        }
        if (this.props.mode === 'CREATE' && this.props.cart.data.items.length > 0) {
            this.props.prevalidateFiles(this.props.currentFolder, this.props.cart.data.items.map(function (x) { return x.id; }), this.props.type);
        }
        else if (this.props.mode === 'VIEW' || this.props.mode === 'EDIT') {
            var id = parseInt(this.props.match.params.id, 10);
            if (isNaN(id)) {
                return;
            }
            this.props.fetchOrder(id, this.props.type === 'AUTOMATIC' ? 'VIEW' : this.props.mode, this.props.type);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    },
    componentDidUpdate: function (prevProps) {
        if (prevProps.isSaving === 'SAVING' &&
            this.props.isSaving === 'SAVED' &&
            this.props.type === 'AUTOMATIC' &&
            this.props.mode === 'CREATE' &&
            this.props.orderId &&
            this.props.wizardStep !== 4) {
            prevProps.history.replace("/".concat((0, translate_1.getLanguage)(), "/projects/").concat(this.props.currentProject.id, "/automatic-orders/edit/").concat(this.props.orderId));
            return;
        }
        if (this.props.cart.data.status !== 'FETCHED' &&
            prevProps.cart.data.status === 'FETCHED' &&
            this.props.mode === 'CREATE' &&
            this.props.cart.data.items.length > 0) {
            this.props.prevalidateFiles(prevProps.currentFolder, prevProps.cart.data.items.map(function (x) { return x.id; }), prevProps.type);
        }
        if (prevProps.deleteStatus === 'STANDBY' &&
            this.props.deleteStatus === 'DELETED') {
            this.props.history.push("/".concat((0, translate_1.getLanguage)(), "/projects/").concat(this.props.currentProject.id, "/automatic-orders"));
        }
        if (prevProps.mode === 'VIEW' && this.props.mode === 'EDIT') {
            var id = parseInt(prevProps.match.params.id, 10);
            if (isNaN(id)) {
                return;
            }
            this.props.fetchOrder(id, this.props.type === 'AUTOMATIC' ? 'VIEW' : this.props.mode, this.props.type);
            this.props.fetchOrderRecipients(id, this.props.mode);
        }
    }
});
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('saveType', 'setSaveType', null), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), lifecycles, recompose_1.pure);
exports.OrderWizardView = enhance(OrderWizardPure);
